import api from '../utils/api';

export const GATE_LABELS = {
  'REG-F1': 'GSTIN verification',
  'REG-F2': 'Bank penny drop',
  'LISTING-F1': 'Price anomaly',
  'LISTING-F2': 'OEM false claim',
  'LISTING-F3': 'Duplicate listing',
  'DISPATCH-F1': 'Photo comparison',
  'E-F1': 'Dispatch photo gate',
  'CHAT-SCAN': 'Chat scanner',
};

export const fraudGateService = {
  listEvents: async (filters = {}) => {
    const response = await api.get('/admin/fraud-gates/events', { params: filters });
    return response.data?.data || [];
  },

  resolveEvent: async (eventId, note = '') => {
    const response = await api.put(`/admin/fraud-gates/events/${eventId}/resolve`, { note });
    return response.data?.data || response.data;
  },

  getSellerRisk: async (sellerId) => {
    const response = await api.get(`/admin/fraud-gates/sellers/${sellerId}/risk`);
    return response.data?.data || response.data;
  },

  clearSoftSuspension: async (sellerId) => {
    const response = await api.post(`/admin/fraud-gates/sellers/${sellerId}/clear-suspension`);
    return response.data?.data || response.data;
  },

  listDispatchReview: async () => {
    const response = await api.get('/admin/fraud-gates/dispatch-review');
    return response.data?.data || [];
  },

  getPhotoChain: async (orderId) => {
    const response = await api.get(`/admin/fraud-gates/photo-chain/${orderId}`);
    return response.data?.data || response.data;
  },

  verifyGstin: async (payload) => {
    const response = await api.post('/seller/onboarding/verify-gstin', payload);
    return response.data?.data || response.data;
  },

  verifyBank: async (payload) => {
    const response = await api.post('/seller/onboarding/verify-bank', payload);
    return response.data?.data || response.data;
  },

  submitDispatchPhoto: async (orderId, { dispatchPhotoUrl, explanation } = {}) => {
    const response = await api.post(`/seller/orders/${orderId}/dispatch-photo`, {
      dispatchPhotoUrl,
      explanation,
    });
    return response.data?.data || response.data;
  },

  getDispatchStatus: async (orderId) => {
    const response = await api.get(`/seller/orders/${orderId}/dispatch-status`);
    return response.data?.data || response.data;
  },

  generateDispatchLabel: async (orderId) => {
    const response = await api.post(`/seller/orders/${orderId}/generate-label`);
    return response.data?.data || response.data;
  },

  confirmDispatchHandoff: async (orderId) => {
    const response = await api.post(`/seller/orders/${orderId}/confirm-handoff`);
    return response.data?.data || response.data;
  },

  listChatMessages: async (orderId) => {
    const response = await api.get(`/orders/${orderId}/chat`);
    return response.data?.data || [];
  },

  sendChatMessage: async (orderId, body) => {
    const response = await api.post(`/orders/${orderId}/chat`, { body });
    return response.data?.data || response.data;
  },

  getChatStatus: async (orderId) => {
    const response = await api.get(`/orders/${orderId}/chat/status`);
    return response.data?.data || response.data;
  },

  sendChatPhoto: async (orderId, file, caption = '') => {
    const form = new FormData();
    form.append('photo', file);
    if (caption) form.append('caption', caption);
    const response = await api.post(`/orders/${orderId}/chat/photo`, form, {
      headers: { 'Content-Type': false },
    });
    return response.data?.data || response.data;
  },

  downloadShippingLabel: async (orderId) => {
    const response = await api.get(`/seller/orders/${orderId}/shipping-label`, {
      responseType: 'blob',
    });
    const blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `shipping-label-${orderId}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  getVoiceState: async (orderId) => {
    const response = await api.get(`/orders/${orderId}/voice`);
    return response.data?.data || response.data;
  },

  requestVoice: async (orderId) => {
    const response = await api.post(`/orders/${orderId}/voice/request`);
    return response.data?.data || response.data;
  },

  acceptVoice: async (orderId, sessionId) => {
    const response = await api.post(`/orders/${orderId}/voice/${sessionId}/accept`);
    return response.data?.data || response.data;
  },

  rejectVoice: async (orderId, sessionId) => {
    const response = await api.post(`/orders/${orderId}/voice/${sessionId}/reject`);
    return response.data?.data || response.data;
  },

  endVoice: async (orderId, sessionId) => {
    const response = await api.post(`/orders/${orderId}/voice/${sessionId}/end`);
    return response.data?.data || response.data;
  },

  adminListSupportTickets: async (params = {}) => {
    const response = await api.get('/admin/comms/support-tickets', { params });
    return response.data?.data || [];
  },

  adminListChatBans: async (params = {}) => {
    const response = await api.get('/admin/comms/chat-bans', { params });
    return response.data?.data || [];
  },

  adminLiftChatBan: async (banId) => {
    const response = await api.post(`/admin/comms/chat-bans/${banId}/lift`);
    return response.data?.data || response.data;
  },

  adminListPhysicalContactStrikes: async (params = {}) => {
    const response = await api.get('/admin/comms/physical-contact-strikes', { params });
    return response.data?.data || [];
  },

  adminResolvePhysicalContactStrike: async (strikeId, action) => {
    const response = await api.put(`/admin/comms/physical-contact-strikes/${strikeId}/resolve`, {
      action,
    });
    return response.data?.data || response.data;
  },

  adminListOrderChat: async (orderId) => {
    const response = await api.get(`/admin/fraud-gates/orders/${orderId}/chat`);
    return response.data?.data || [];
  },
};
